import { render, staticRenderFns } from "./ExpiredView.vue?vue&type=template&id=a8809c44&"
import script from "./ExpiredView.vue?vue&type=script&lang=js&"
export * from "./ExpiredView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports